import { render, staticRenderFns } from "./tanks.vue?vue&type=template&id=6ad28888&scoped=true&"
var script = {}
import style0 from "./tanks.vue?vue&type=style&index=0&id=6ad28888&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad28888",
  null
  
)

export default component.exports